<template>

  <div class="pb pb-feed">

    

    <SkWeekOpenedV2
      v-if="weekDataStatus === 'pending' && start === 0"
      :count="limit"
    />

    <div 
      v-else-if="weekData?.items?.length" 
      class="weeks strains_items"
    >

    <template v-for="(item, index) in weekData.items" :key="index">

      <FeedWeek
        :diary="item.item_diary"
        :user="item.item_user"
        :items-seed="item.items_seed"
        :week="item"
        :matches="item.matches"
        :num="index"
      />
    </template>


    </div>

    <UiEmpty
      v-else
    />

    <ClientOnly>
      <UiInfinityScroll 
        v-if="weekDataStatus === 'success' && weekData?.items?.length"
        :is-loading="weekDataStatus === 'pending'"
        @click="start = start + limit"        
        ref="elInfinityScroll"
      />
    </ClientOnly>

 

  </div>

</template>

<script setup lang="ts"> 

interface weekData {
  items: Strain[],
  items_tag: Tag[]
}

import { TagsStrains2, getTagsKeys, getTagsSimple } from '@/types/other'
import type { Strain } from '@/types/strain'
import type { Tag } from '@/types/other'
import { EStrainsFilters, RStrainCategoriesLinks, RStrainCategoriesImages } from '@/types/strain'
import {strains} from '~/i18n/strains/en.js'
import { useIntersectionObserver } from '@vueuse/core'
import { watchArray } from '@vueuse/core'


const route = useRoute();
const isEnded = ref(false)
const tags = ref(structuredClone(TagsStrains2))
const {$api, $adv, $ga, $patcher} = useNuxtApp()
const elInfinityScroll = ref(null)
const elList = ref(null)

const props = defineProps({
  inurl: {
    type: String,
    required: false
  },
  pageCategoryId: {
    type: String,
    required: false
  },
  pageCategoryVal: {
    type: String,
    required: false
  },
})

const start = ref(0)
const limit = ref(20)
// const page = ref(1)
const query = ref('')
const sort = ref('create')
const tagscount = ref([])
// const tagsSelected = ref(route.params['tag']?.length ? route.params['tag'] : ( route.query?.tags ? route.query.tags.split(",") : []))
const tagsSelected = ref([])
const list = ref([])
const keyword = ref(route.query['keyword']?.length ? route.query['keyword'] : '')

const tagsPermanent = ref([])

  

const loadData = async function() {  
  const response = await $api.getWeeksFollowers(useAuth().getId(), {
    start: start.value,
    limit: limit.value,
    keyword: keyword.value,
    sortable: sort.value,
    tagsall: getTagsKeys(tags.value), 
    tags: getTagsSimple(tags.value, tagsSelected.value),
    tagsper: getTagsSimple(tags.value, tagsPermanent.value)
  });
  return response;  
}


const { status: weekDataStatus, refresh: refreshData, data: weekData } = await useLazyAsyncData('weekData', async () => await loadData() as weekData)
 

watchArray([start], async ([newStart], added, removed) => {

  weekDataStatus.value = 'pending';
  var dt = await loadData();

  if(newStart === 1){
    weekData.value.items = [];
    isEnded.value = false;
  }
    
  if(dt.length === 0)
    isEnded.value = true;  

  weekData.value.items = [...weekData.value.items, ...dt.items]
  if(newStart === 0)
    weekData.value.items_tag = dt.items_tag
  weekDataStatus.value = 'success';

  
  $adv.apply();

}, {deep: true})



useIntersectionObserver(
  elInfinityScroll,
  ([{isIntersecting}]) => {
    if(isIntersecting){
      console.log('infinity scroll event');        
      if(weekDataStatus.value !== 'loading' && !isEnded.value)
        start.value = start.value + limit.value;
    }
  },
  { distance: 10 }
)

$adv.apply();

console.log('head', useNuxtApp().$head.getFeed())
useHead(useNuxtApp().$head.getFeed());


 

</script>

<style scoped>

.pb{

  max-width: 935px !important;
  margin-left: auto;
  margin-right: auto;
}
.weeks{
  /* display: flex; */
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 100%;

  flex-direction: column;
  margin-top: 1rem;
}
h1{
  margin-right: auto;
}

.add_filter_box{
  display: flex;
  margin-left: auto;
}

.headerow{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-bottom: 1rem;
}

.headerow h1{
  width: 100%;
    display: flex
;
    align-items: center;
    gap: 0.5rem;
}
.headerow h1 span{}
.headerow h1 img{
  max-width: 30px;
}

.headerow .desc:deep(p){
  margin-top: 0;
  font-size: 1rem;
}

.headerow .desc:deep(a){
  color: var(--un-firm);
  text-decoration: underline;
}

.srt{
    display: flex;
    justify-content: flex-end;
    margin-left: auto;    
}


.fltbar{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;

}

.fltbar .flttags{
    display: flex;
    align-items: center;
    gap: 10px;
}

.fltbar .flttags .total{

    font-weight: 600;
}
 

.fltbar .flttags .total:before{
    margin-right: 5px;
}

@container pb (max-width: 700px) {
  .headerow{

  }
  .headerow > .search{
    order: 1;
    width: 100%;
  }
  .headerow > .stags{
    order: 0;
    margin: 0;
  }
  .headerow > .sort{
    order: 2;
    justify-content: flex-end;
    width: 100%;
    margin: 0;
  }
  .weeks{
    margin-top: 0rem;
  }
}


/* to top */

.to-top-btn{
  margin: 0rem auto;
  padding: 1rem;
  display: flex;
  width: fit-content;
  cursor: pointer;
}
 
</style>
